import React, { useState, useMemo } from "react";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import { FAQSection } from "../components/camperDetails";
import { useTranslation } from "../hooks/useTranslation";
import { SEO, generateFAQSchema, generateBreadcrumbSchema } from "../seo";
import "../styles/faq/FAQ.css";

const FAQ = () => {
  const { t, getLocalizedPath } = useTranslation('faq');
  const [selectedCategory, setSelectedCategory] = useState("all");

  const faqCategories = [
    { text: t('categories.all'), category: "all" },
    { text: t('categories.booking'), category: "booking" },
    { text: t('categories.insurance'), category: "insurance" },
    { text: t('categories.travel'), category: "travel" },
    { text: t('categories.equipment'), category: "equipment" },
    { text: t('categories.surf'), category: "surf" },
  ];

  const allFAQs = t('faqs', { returnObjects: true }).map((faq, index) => ({
    ...faq,
    isOpen: index === 0
  }));

  // SEO Schemas
  const faqSchema = generateFAQSchema(allFAQs);
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: 'Home', path: '' },
    { name: 'FAQ', path: '/faq' },
  ]);

  const filteredFAQs = useMemo(() => {
    if (selectedCategory === "all") {
      return allFAQs;
    }
    return allFAQs.filter(faq => faq.category === selectedCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="faq-page">
      <SEO schema={[faqSchema, breadcrumbSchema].filter(Boolean)} />
      <Header />

      <div className="faq-page-container">
        <div className="faq-page-hero">
          <div className="faq-page-hero-content">
            <h1 className="faq-page-title">{t('page.title')}</h1>
            <p className="faq-page-subtitle">
              {t('page.subtitle')}
            </p>
          </div>
        </div>

        <div className="faq-categories">
          <div className="faq-categories-container">
            {faqCategories.map((category, index) => (
              <div
                key={index}
                className={`faq-category-chip ${selectedCategory === category.category ? "active" : ""}`}
                onClick={() => handleCategoryChange(category.category)}
                style={{ cursor: "pointer" }}
              >
                <div className="faq-chip-content">{category.text}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="faq-page-content">
          <FAQSection faqs={filteredFAQs} hideHeader={true} />
        </div>

        <div className="faq-page-contact">
          <div className="faq-contact-content">
            <h2>{t('page.contact.title')}</h2>
            <p>
              {t('page.contact.description')}
            </p>
            <div className="faq-contact-buttons">
              <a href={getLocalizedPath("/contact")} className="faq-contact-button primary">
                {t('page.contact.contactButton')}
              </a>
              <a href="mailto:info@suncatchers.pt" className="faq-contact-button secondary">
                {t('page.contact.emailButton')}
              </a>
            </div>
          </div>
        </div>
      </div>

      <CheckoutFooter />
    </div>
  );
};

export default FAQ;